(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (directory) => {
      if (directory.dataset.brandDirectoryReady === 'true') return;
      const tools = directory.querySelector('[data-brand-tools]');
      const search = directory.querySelector('[data-brand-search]');
      const clear = directory.querySelector('[data-brand-clear]');
      const buttons = Array.from(directory.querySelectorAll('[data-brand-letter]'));
      const groups = Array.from(directory.querySelectorAll('[data-brand-group]'));
      const status = directory.querySelector('[role="status"]');
      const empty = directory.querySelector('[data-brand-no-results]');
      if (!tools || !search || !clear || !status || !empty) return;
      directory.dataset.brandDirectoryReady = 'true';
      tools.hidden = false;
      let activeLetter = 'all';

      const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        groups.forEach((group) => {
          let inGroup = 0;
          group.querySelectorAll('[data-brand-item]').forEach((item) => {
            const name = item.querySelector('a')?.textContent?.trim().toLocaleLowerCase() || '';
            const match = (activeLetter === 'all' || activeLetter === group.dataset.brandGroup) && (!query || name.includes(query));
            item.hidden = !match;
            if (match) inGroup += 1;
          });
          group.hidden = inGroup === 0;
          visible += inGroup;
        });
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.brandLetter === activeLetter)));
        clear.hidden = query.length === 0;
        empty.hidden = visible !== 0;
        status.textContent = visible === 0 ? directory.dataset.noResults : directory.dataset.statusTemplate.replace('__VISIBLE__', String(visible));
      };

      search.addEventListener('input', () => { activeLetter = 'all'; update(); });
      clear.addEventListener('click', () => { search.value = ''; activeLetter = 'all'; update(); search.focus(); });
      buttons.forEach((button) => button.addEventListener('click', () => { activeLetter = button.dataset.brandLetter; update(); }));
      directory.querySelectorAll('[data-brand-top]').forEach((link) => link.addEventListener('click', (event) => {
        const title = directory.querySelector(link.getAttribute('href'));
        if (!title) return;
        event.preventDefault();
        title.focus({ preventScroll: true });
        title.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        window.history.replaceState(null, '', link.getAttribute('href'));
      }));
      update();
    };
    document.querySelectorAll('[data-brand-directory]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-brand-directory]')) init(event.target);
      event.target.querySelectorAll('[data-brand-directory]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
